import { Spinner } from "office-ui-fabric-react";
import React, { Component } from "react";

interface LoadingSectionProps {
    style?: React.CSSProperties;
    text?: string;
    loading?: boolean;
    dependantObjects: any[];
    defaultMessage?: string;
    defaultOnEmpty?: boolean;
}

interface LoadingSectionState {

}

export default class LoadingSection extends Component<LoadingSectionProps, LoadingSectionState>
{
    constructor(props: LoadingSectionProps) {
        super(props);
        this.state = {};
    }

    public render() {
        var objectsLeftToLoad = this.props.dependantObjects.filter(s => s === undefined).length;
        
        //If objects still left to load and still loading if passed or if not passed show loading
        if (objectsLeftToLoad > 0 && (this.props.loading === true || this.props.loading === undefined)) {
            return (<Spinner label={this.props.text || "Loading..."} labelPosition="right" />);
        }

        //If objects failed to load OR any dependant objects are empty arrays and set to default on empty
        if (objectsLeftToLoad > 0 || (this.props.defaultOnEmpty && this.props.dependantObjects.filter(s => Array.isArray(s) && s.length == 0).length > 0)) {
            return (
                <div className="default-message">
                    {this.props.defaultMessage}
                </div>
            )
        }       

        return (this.props.children)
    }
}